import ServiceTemplate from '@/components/ServiceTemplate';

export default function RegisterCopyright() {
  const data = {
    title: 'Copyright Registration Services',
    subtitle: 'Protect your creative works with federal copyright registration and enforcement support.',
    overviewTitle: 'Why Register Your Copyright?',
    overviewImage: 'https://images.unsplash.com/photo-1457369804613-52c61a468e7d',
    description: [
      'Copyright registration provides crucial legal protection for your original creative works. While copyright exists automatically upon creation, federal registration offers significant legal advantages including the ability to sue for infringement and claim statutory damages.',
      'Our comprehensive copyright registration service handles all aspects of the application process, from proper classification to preparing deposit materials and responding to examiner inquiries.',
      'We ensure your creative works receive maximum protection under copyright law, giving you peace of mind to focus on creating.'
    ],
    benefits: [
      { title: 'Legal Protection', description: 'Public record of ownership and exclusive rights to your work.' },
      { title: 'Litigation Rights', description: 'Ability to file infringement lawsuits in federal court.' },
      { title: 'Statutory Damages', description: 'Eligibility for statutory damages up to $150,000 per infringement.' },
      { title: 'Attorney Fees', description: 'Potential recovery of attorney fees in infringement cases.' },
      { title: 'Customs Protection', description: 'U.S. Customs can block importation of infringing copies.' },
      { title: 'Licensing Opportunities', description: 'Strong foundation for licensing and monetization deals.' }
    ],
    process: [
      { title: 'Research & Analysis', description: 'Comprehensive search and analysis to identify potential conflicts or issues.' },
      { title: 'Application Preparation & Filing', description: 'Expert preparation and filing of complete applications with all required documentation.' },
      { title: 'Monitoring & Approval', description: 'Track application progress and address any office actions until successful approval.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Single work registration',
        price: '$199',
        period: '+ filing fees ($45-$65)',
        features: [
          'Single work registration',
          'Copyright Office filing',
          'Application preparation',
          'Certificate delivery',
          'Email support',
          'Standard processing'
        ]
      },
      {
        name: 'Professional',
        description: 'Multi-work package',
        price: '$399',
        period: '+ filing fees',
        featured: true,
        features: [
          'Up to 5 works registration',
          'Expedited filing available',
          'Comprehensive documentation',
          'Priority processing',
          'Copyright monitoring (6 months)',
          'Phone support',
          'Enforcement consultation'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Portfolio management',
        price: '$799',
        period: '+ filing fees',
        features: [
          'Unlimited registrations',
          'Portfolio strategy planning',
          'Ongoing monitoring',
          'DMCA takedown services',
          'Infringement detection',
          'Legal representation',
          'Dedicated account manager'
        ]
      }
    ],
    faqs: [
      { question: 'What can be copyrighted?', answer: 'Original literary, musical, dramatic, artistic, and certain other intellectual works including software, photos, videos, and architectural designs.' },
      { question: 'How long does registration take?', answer: 'Standard processing takes 8-12 months, though expedited processing (1-5 business days) is available for an additional fee.' },
      { question: 'When does copyright protection begin?', answer: 'Copyright exists from the moment of creation, but registration provides important legal benefits and is required to file infringement lawsuits.' },
      { question: 'How long does copyright last?', answer: 'For works created after 1978, copyright generally lasts for the author\'s life plus 70 years.' },
      { question: 'Do I need to register every work?', answer: 'Registration isn\'t required but is strongly recommended for valuable works you may need to defend legally.' },
      { question: 'Can I register multiple works?', answer: 'Yes, collections of related works can often be registered together under certain circumstances, reducing per-work costs.' },
      { question: 'What if my work is already published?', answer: 'Published works can still be registered, though some benefits require registration within specific timeframes after publication.' },
      { question: 'Do I need copyright notice on my work?', answer: 'Copyright notice isn\'t required but is recommended to inform others of your rights and deter infringement.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
